export function padNumber(number: number) {
    return String(number).padStart(2, '0');
}

export function getDisplayTime(time: number) {
    return `${padNumber(Math.floor(time / 60))}:${padNumber(Math.round(time % 60))}`;
}
